module.exports = __webpack_public_path__ + "img/caa.5e7cfe8f.png";